"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Policy = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const i18n_1 = require("../../i18n");
const policy_style_1 = require("./policy.style");
exports.Policy = (0, react_1.memo)(({ value, onChange }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const handleChange = (event) => {
        const target = event.target;
        onChange(target.checked);
    };
    return ((0, jsx_runtime_1.jsx)(policy_style_1.StyledCheckbox, { checked: value, onChange: handleChange, label: t('SMART:InsurancePeriod.labels.policyOnYear', {
            defaultValue: i18n_1.i18nDefaultValues.InsurancePeriod.labels.policyOnYear,
        }) }));
});
